import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
import DatePicker from "../../../../../components/lib/SafeLeaseDatePicker";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { usePrivatePolicySettingsStore } from "../../usePrivatePolicySettingsStore/usePrivatePolicySettingsStore";
import dayjs from "dayjs";

function PpeNewOptions({ privatePolicyConfigs = [] }: { privatePolicyConfigs?: any[] }) {
  const ppeNewEnabled = usePrivatePolicySettingsStore((state) => state.ppeNewEnabled);
  const selectedPpeNewDate = usePrivatePolicySettingsStore((state) => state.selectedPpeNewDate);
  const setSelectedPpeNewDate = usePrivatePolicySettingsStore((state) => state.setSelectedPpeNewDate);
  const [ppeNewDateError, setPpeNewDateError] = useState(false);

  const handleDateChange = (date: Date) => {
    const dayJsDate = dayjs(date);
    if (dayJsDate.isValid()) {
      if (dayJsDate.isBefore(dayjs(), "day")) {
        if (privatePolicyConfigs.some((config) => dayjs(config.ppeNewDate).isSame(dayJsDate, "day"))) {
          setPpeNewDateError(false);
          setSelectedPpeNewDate(dayJsDate);
        } else {
          setPpeNewDateError(true);
        }
      } else {
        setPpeNewDateError(false);
        setSelectedPpeNewDate(dayJsDate);
      }
    } else {
      setPpeNewDateError(true);
    }
  };

  return (
    <>
      <Stack alignItems="center" spacing={1} direction="row">
        <Typography variant="h6">PPE New Date</Typography>
        <Tooltip placement="right" title="This is the date after which new move-ins will be subject to PPE.">
          <InfoOutlinedIcon color="disabled" />
        </Tooltip>
      </Stack>
      <Box>
        <DatePicker
          label="Date"
          disabled={!ppeNewEnabled}
          value={selectedPpeNewDate ? dayjs(selectedPpeNewDate) : null}
          onChange={handleDateChange}
          slotProps={{
            textField: {
              error: ppeNewDateError,
              helperText: ppeNewDateError ? "Date must be valid and in the future" : "",
            },
          }}
          disablePast
        />
      </Box>
    </>
  );
}

export default PpeNewOptions;
